import { useEffect, useState } from 'react';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { InputSize } from 'components/Dropdown/types';
import { SELECT } from './constants';
import { messages } from './messages';
import { StyledDropdown } from './styled';
import { CashInBankAccountsPropsType, DropdownOption } from './types';

export const CashInBankAccountDropdown = ({
  cashInBankAccounts,
  onCashInBankAccountChange,
  isLoading,
  isValidCashInBankAccount
}: CashInBankAccountsPropsType): React.JSX.Element => {
  const intl: IntlShape = useIntl();
  const [isCBAError, setIsCBAError] = useState<boolean>(false);
  const [cashInBankAccount, setCashInBankAccount] = useState<DropdownOption>({
    label: intl.formatMessage(messages.cbaDropdownDefaultVal),
    value: SELECT,
    postingDescriptionRequired: true
  });

  const handleCBAValidation = (cashInBankAccValue: string) => {
    setIsCBAError(cashInBankAccValue === SELECT);
  };

  const handleCashInBankAccounts = (selectedValue: DropdownOption) => {
    handleCBAValidation(selectedValue.value);
    setCashInBankAccount(selectedValue);
    onCashInBankAccountChange(selectedValue);
  };

  useEffect(() => {
    setIsCBAError(isValidCashInBankAccount);
  }, [isValidCashInBankAccount]);

  return (
    <StyledDropdown
      isLoading={isLoading}
      inputId="cashInBankAccount"
      dataTestId="cashInBankAccount"
      label={
        <FormattedMessage
          description="Label for Cash In Bank Accounts dropdown"
          defaultMessage="CIB Account"
        />
      }
      placeHolder={
        <FormattedMessage
          description="Place holder message for CIB"
          defaultMessage="Select"
        />
      }
      onChange={handleCashInBankAccounts}
      options={cashInBankAccounts || []}
      value={cashInBankAccount}
      size={InputSize.SMALL}
      isRequired
      errorMessage={
        <FormattedMessage
          description="Label for select a Cash In Bank Account"
          defaultMessage="CIB Account is required"
        />
      }
      hasError={isCBAError}
      enableCustomValidation
    />
  );
};
